import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChickenLeg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M20.52,12.05c-2.76,2.76-7.5,3.66-9.87,1.3S9.19,6.24,12,3.48a5.88,5.88,0,0,1,8.69-.12A5.88,5.88,0,0,1,20.52,12.05Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M12.43,14.43,8.84,18a1.94,1.94,0,0,0-.54,1.89,2,2,0,1,1-3.86,1.15,2.21,2.21,0,0,0-1.5-1.5A2,2,0,1,1,4.09,15.7,1.94,1.94,0,0,0,6,15.16l3.59-3.59"
		})
	]
});
const ForwardRef = forwardRef(SvgChickenLeg);
export default ForwardRef;
